import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import { CloseOutlined } from "@material-ui/icons";
import MyTypography from "@saleor/components/MyTypography";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

interface UserADProps {
  result: any;
  open: boolean;
  onClose: () => void;
  onChoose: (value) => void;
}

const useStyles = makeStyles(
  theme => ({
    root: {
      "& .MuiPaper-root": {
        minWidth: 400,
        boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
        borderRadius: 16,
        padding: 24,
        overflow: "auto"
      }
    },
    dialogTitle: {
      padding: 0,
      "& .MuiTypography-root": {
        display: "flex",
        alignItems: "center"
      }
    },
    dialogFooter: {
      borderTop: 0,
      padding: 0,
      justifyContent: "space-between",
      gap: 24,
      "& button": {
        width: "100%"
      },
      "& .MuiTypography-root": {
        color: "inherit"
      }
    },
    mainTitle: {
      color: theme.palette.info.main
    },
    closeIcon: {
      marginLeft: "auto",
      cursor: "pointer"
    },
    dialogCenter: {
      padding: "0px !important",
      marginTop: "10px !important"
    },
    numberResult: {
      fontWeight: 700
    },
    boxTable: {
      border: `solid 1px ${theme.palette.grey[300]}`,
      marginTop: 16,
      marginBottom: 16
    },
    noResultText: {
      marginTop: 16,
      marginBottom: 16,
      color: theme.palette.error.light
    },
    buttonAction: {
      width: "50%",
      height: 48
    },
    rowClickable: {
      cursor: "pointer"
    }
  }),
  { name: "ModalUserAD" }
);

const ModalUserAD: React.FC<UserADProps> = props => {
  const { result, open, onClose, onChoose } = props;
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Dialog
      data-testid="modalUserAD"
      className={classes.root}
      open={open}
      onClose={onClose}
    >
      <DialogTitle className={classes.dialogTitle}>
        <MyTypography variant={"h6"} className={classes.mainTitle}>
          {intl.formatMessage({ defaultMessage: "AD User" })}
        </MyTypography>
        <CloseOutlined className={classes.closeIcon} onClick={onClose} />
      </DialogTitle>
      <DialogContent className={classes.dialogCenter}>
        <MyTypography variant={"body3"}>
          {intl.formatMessage({ defaultMessage: "Search Results" })}
        </MyTypography>
        {result?.success ? (
          <div className={classes.boxTable}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCellHeader>
                    <MyTypography variant={"captionBold"}>
                      {intl.formatMessage({ defaultMessage: "Code" })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader>
                    <MyTypography variant={"captionBold"}>
                      {intl.formatMessage({ defaultMessage: "Name" })}
                    </MyTypography>
                  </TableCellHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow
                  key={result.routeCode}
                  className={classes.rowClickable}
                  onClick={() => onChoose(result)}
                >
                  <TableCell>
                    <MyTypography variant={"body2"}>
                      {result.employeeId}
                    </MyTypography>
                  </TableCell>
                  <TableCell>
                    <MyTypography variant={"body2"}>
                      {`${result.firstName} ${result.lastName}`}
                    </MyTypography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        ) : (
          <MyTypography className={classes.noResultText} variant={"body2"}>
            ไม่พบข้อมูลที่ค้นหา
          </MyTypography>
        )}
      </DialogContent>
      <DialogActions disableSpacing={true} className={classes.dialogFooter}>
        {result?.success ? (
          <>
            <Button
              data-testid="close-button"
              variant={"outlined"}
              color={"secondary"}
              className={classes.buttonAction}
              onClick={onClose}
            >
              <FormattedMessage defaultMessage={"กลับไป"} />
            </Button>
            <Button
              data-testid="confirm-button"
              variant={"contained"}
              color={"secondary"}
              className={classes.buttonAction}
              onClick={() => onChoose(result)}
            >
              <FormattedMessage defaultMessage={"ยืนยัน"} />
            </Button>
          </>
        ) : (
          <Button
            variant={"contained"}
            color={"secondary"}
            className={classes.buttonAction}
            onClick={onClose}
          >
            <FormattedMessage defaultMessage={"ปิดหน้าต่าง"} />
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ModalUserAD;
